import Vue from 'vue';
import firebase from 'firebase/app';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

// Initialize Firebase
firebase.initializeApp({
  apiKey: 'AIzaSyD5FFOEoK_whftRiymyonaeOM-CG7PfjUo',
  authDomain: 'ondivan-staging.firebaseapp.com',
  databaseURL: 'https://ondivan-staging.firebaseio.com',
  projectId: 'ondivan-staging',
  storageBucket: 'ondivan-staging.appspot.com',
  messagingSenderId: '941218487207',
});

new Vue({
  i18n,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app');


// let app = '';

// firebase.auth().onAuthStateChanged(() => {
//   if (!app) {
//     app = new Vue({
//       router,
//       render: h => h(App),
//     }).$mount('#app');
//   }
// });
